import { joinDriverLicense } from 'store/insuranceAnketa/mapperHelper';

import { NAMES } from './DriverLicense.constants';

export const generatePreviousLicense = ({ previousLicenseParts, key, value }) => {
  const { [NAMES.PREVIOUS_SERIES]: seriesParam, [NAMES.PREVIOUS_NUMBER]: number } = {
    ...previousLicenseParts,
    [key]: value,
  };

  const series = String(seriesParam).padEnd(4, ' ');

  return joinDriverLicense({ number, series });
};

export const splitDriverLicense = ({ seriesAndNumber }) => {
  return Array.from(seriesAndNumber).reduce(
    (acc, letter, index) => {
      const result = letter === ' ' ? '' : letter;

      if (index < 4) {
        acc.series += result;
      } else if (result) {
        acc.number += result;
      }

      return acc;
    },
    { number: '', series: '' }
  );
};

export const generatePreviousLicenseParts = ({ previousLicense }) => {
  const { number, series } = splitDriverLicense({ seriesAndNumber: previousLicense });

  return { [NAMES.PREVIOUS_NUMBER]: number, [NAMES.PREVIOUS_SERIES]: series };
};
